import {redboothRequest} from "@/graphql/queries";

require("dotenv").config();
import redboothHelper from "../helpers/redbooth";
const axios = require('axios').default;
import { API, graphqlOperation, } from 'aws-amplify';
import { createRequest, createPage, createFile, sendEmail } from "../graphql/mutations";

const redboothConfig = {
    agentUsername: "supporttri",
    agentPassword: "jFA0@D52oB",
    defaultProjectID: "920706", // [1] Media - Web Updates
    defaultTaskListID: "2144417", // [1] Incoming Request
    redboothURL: "https://redbooth.com/api/2/",
    baseURL: "https://teamtri-cors-server.herokuapp.com/https://redbooth.com/api/2/",
    cc: "@jasonishibashi, @joshuamacfawn"
};

if(process.env.NODE_ENV === "development") {
    // redboothConfig.baseURL = redboothConfig.proxy + redboothConfig.baseURL;
    redboothConfig.defaultProjectID = "920706";
    redboothConfig.defaultTaskListID = "2144417";
    redboothConfig.cc = "@joshuamacfawn"
}

export default async function processForm(formData) {
    return new Promise( function (resolve, reject) {
        createTask(formData)
            .then(redboothTask => createComment(redboothTask, formData))
            .then(redboothTask => saveToApp(redboothTask, formData))
            .then(redboothTask => deliverEmail(redboothTask, formData))
            .then(result => resolve(result))
            .catch(error => reject(error));
    })
}

function createTask(formData) {
    return new Promise( function(resolve, reject) {
        const request = {
            httpMethod: 'post',
            endpoint: 'tasks',
            data: {
                project_id: redboothConfig.defaultProjectID,
                task_list_id: redboothConfig.defaultTaskListID,
                name: redboothHelper.displayTitle(formData),
                description: redboothHelper.createDescription(formData),
                due_on: formData.dueDate,
                urgent: formData.urgent,
                position: 0
            }
        };

        API.graphql(graphqlOperation(redboothRequest, {
            request: JSON.stringify(request)
        })).then(response => {
            console.log(JSON.parse(response.data.redboothRequest))
            resolve(JSON.parse(response.data.redboothRequest))
        }).catch(error => reject(error))


        // redboothRequest('POST', 'tasks', request)
        // // After creating the initial task in Redbooth, take the response and pass that back
        //     .then(task => resolve(task))
        //     // If not able to create task in redbooth, send back an error
        //     .catch(error => reject(error));
    });
}

function createComment(redboothTask, formData) {
    return new Promise(function (resolve, reject) {
        const request = {
            httpMethod: 'post',
            endpoint: 'comments',
            data: {
                target_type: "Task",
                target_id: redboothTask.id,
                body: "cc: " + redboothHelper.ccList(formData.organization)
            }
        };

        API.graphql(graphqlOperation(redboothRequest, {
            request: JSON.stringify(request)
        }))

        // redboothRequest("POST", "comments", comment);

        // After I have created the subtask
        resolve(redboothTask);

        // If not able to create the comment in redbooth, send back an error
        reject("Could not create comment.")
    })
}

function saveToApp(redboothTask, formData) {
    return new Promise(function (resolve, reject) {
        API.graphql(graphqlOperation(createRequest, {
            input: {
                status: "Received",
                userID: formData.userID,
                ticketID: redboothHelper.findTicketID(redboothTask.description),
                redboothID: redboothTask.id,
                title: formData.title,
                websiteID: formData.website.id,
                urgent: formData.urgent,
                dueDate: formData.dueDate,
                orgID: formData.organization.id
            }
        }))
            .then(result => {
                const requestID = result.data.createRequest.id;

                for(let i = 0 ; i < formData.pages.length ; i++) {
                    API.graphql(graphqlOperation(createPage, {
                        input: {
                            requestID: requestID,
                            url: formData.pages[i].url,
                            description: formData.pages[i].description
                        }
                    })).catch(error => console.log(error))
                }

                if(formData.files.length > 0) {
                    for(let i = 0 ; i < formData.files.length ; i++) {
                        API.graphql(graphqlOperation(createFile, {
                            input: {
                                requestID: requestID,
                                name: formData.files[i].name,
                                s3Key: formData.files[i].s3Key
                            }
                        })).catch(error => console.log(error))
                    }
                }
                resolve(result.data.createRequest);
            })
            .catch(error => reject(error))
    })
}

function deliverEmail(redboothTask, formData) {

    // Don't send email if just testing locally.
    // Comment out this code temporarily if you want to locally test the sending of an email.
    if (process.env.NODE_ENV === "development") {
        return new Promise(function (resolve, reject) {
            resolve(redboothTask);
        })
    }

    return new Promise(function(resolve, reject) {
        const infoForEmailMessage = {
            firstName: formData.fullName.substring(0, formData.fullName.search(" ")),
            ticketID: redboothTask.ticketID,
            urgent: redboothHelper.translateUrgent(formData.urgent),
            pages: redboothHelper.translatePages(formData.pages),
            files: redboothHelper.translateFiles(formData.files),
            dueDate: new Date(formData.dueDate + "T12:00:00").toLocaleDateString(),
            domain: formData.website.domain,
            title: formData.title
        };

        const email = {
            email: formData.email,
            fullName: formData.fullName,
            message: redboothHelper.emailMessage(infoForEmailMessage)
        };

        API.graphql(graphqlOperation(sendEmail, email))
            .then(() => resolve(redboothTask))
            .catch(error => console.log(error))
    })
}

export async function getUsers() {
    return new Promise(function (resolve) {
        const request = {
            httpMethod: 'GET',
            endpoint: 'users'
        }

        API.graphql(graphqlOperation(redboothRequest, {
            request: JSON.stringify(request)
        })).then(response => {
            console.log("FROM THE USERS CALL", response.data.redboothRequest)
            resolve(JSON.parse(response.data.redboothRequest).sort(sortOrder("first_name")))
        })

        // redboothRequest("GET", "users")
        //     .then(d => resolve(d.data.sort(sortOrder("first_name"))))
    })
}

// Sort users in alphabetical order by first name
function sortOrder(prop) {
    return function(a, b) {
        if (a[prop] > b[prop]) {
            return 1;
        } else if (a[prop] < b[prop]) {
            return -1;
        }
        return 0;
    }
}


// function redboothRequest(method, endpoint, data) {
//     return new Promise(function(resolve, reject) {
//         axios({
//             method: method,
//             url: redboothConfig.baseURL + endpoint,
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Access-Control-Allow-Origin': '*',
//                 'Access-Control-Allow-Credentials': true,
//                 'Access-Control-Allow-Methods' : 'GET, POST',
//                 'X-Requested-With': 'XMLHttpRequest',
//                 async: true,
//                 crossDomain: true,
//                 // Base 36 encode of Support TRI username/password
//                 Authorization: 'Basic c3VwcG9ydHRyaTpqRkEwQEQ1Mm9C'
//             },
//             data: JSON.stringify(data)
//         })
//             .then(response => resolve(response))
//             .catch(error => reject(error));
//     })
// }

